import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import App from './App';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

const cache = createCache({
  key: 'mui',
  prepend: true,
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <CacheProvider value={cache}>
    <App />
  </CacheProvider>
);
